import { cn } from "@/lib/utils"
import { statisticsShadcnCardClassName } from "../../Statistics/components/statisticsShadcnCardShell"

/** Dashboard chart/calendar cards — dark mode matches Trade Log sidebar surface. */
export const dashboardSidebarSurfaceCardClassName =
  "dark:bg-sidebar dark:text-white"

/** Muted labels/copy on dashboard cards — grey in light, full white in dark. */
export const dashboardMutedTextClassName =
  "text-muted-foreground dark:!text-white"

export const dashboardMutedGrayTextClassName =
  "text-gray-500 dark:!text-white"

/** Dashboard chart cards (portfolio growth, win rate) — matches legacy ChartCard chrome. */
export const dashboardChartCardClassName = cn(
  statisticsShadcnCardClassName,
  dashboardSidebarSurfaceCardClassName,
  "mb-0 gap-0 rounded-md py-0"
)

export const dashboardChartCardHeaderClassName =
  "mb-5 px-[22px] pt-7 pb-0 has-data-[slot=card-action]:grid-cols-[1fr_auto]"

export const dashboardChartCardContentClassName =
  "flex h-[300px] min-h-[300px] max-h-[300px] w-full flex-col overflow-hidden px-3 pb-5 pt-0"

/** Trading activity calendar — full-width dashboard card. */
export const dashboardActivityCalendarCardClassName = cn(
  statisticsShadcnCardClassName,
  dashboardSidebarSurfaceCardClassName,
  "flex min-h-0 max-h-full flex-col gap-0 rounded-md py-0 md:min-h-[620px] lg:min-h-[700px]"
)

/** Skeleton fills on dashboard sidebar surfaces (calendar day modal, etc.). */
export const dashboardSidebarSkeletonClassName =
  "bg-muted dark:bg-sidebar-accent"

export const dashboardActivityCalendarHeaderClassName =
  "mb-5 shrink-0 px-[22px] pt-7 pb-0"

export const dashboardActivityCalendarContentClassName =
  "min-h-0 min-w-0 flex-1 overflow-hidden px-3 pb-4 pt-0 sm:px-[22px]"
